import { Component, OnDestroy, OnInit } from '@angular/core';
import { SpinnerService } from '../service/spinner.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'progress-spinner',
  templateUrl: 'progress-spinner.html',
  styleUrls: ['progress-spinner.scss'],
})
export class ProgressSpinnerComponent implements OnInit, OnDestroy {
  showSpinner: boolean;
  private unsubscribe: Subscription[] = [];
  constructor(private spinnerService: SpinnerService) {
  
  }

  ngOnDestroy()  {
    this.unsubscribe.forEach(s => s.unsubscribe());
  }

  ngOnInit() {
    this.unsubscribe.push(this.spinnerService.visibility.subscribe(spin => this.showSpinner = spin));
  }
}
